import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';

/**
 * canMatch guard for authenticated routes.
 *
 * Always returns true so the auth route group is always "matchable".
 * This allows canActivate (authGuard) to run and redirect to /login
 * when the user is not authenticated.
 *
 * Previously this returned `false` when unauthenticated, which caused
 * the route to be skipped entirely — falling through to the wildcard
 * ** → /not-found instead of redirecting to /login.
 *
 * Route disambiguation between guest/auth is handled by:
 * - noAuthMatch on guest routes (returns true when NOT authenticated)
 * - Angular's first-match-wins: guest routes are declared first,
 *   so /login matches guest route when unauthenticated
 * - authGuard (canActivate) redirects to /login for auth routes
 *   when unauthenticated
 */
export const authMatch: CanMatchFn = () => {
  return true;
};
